import React from 'react';
import clsx from 'clsx';

import { logEvent } from '../../lib/analytics';
import { useVoiceDemo } from '../../providers/VoiceDemoContext';
import type { StyleDetail } from '../elements/StyleJigsaw';

export const StyleSelector = ({ languages }: { languages: StyleDetail[] }) => {
  const { currentStyle, handleUpdateStyle } = useVoiceDemo();
  return (
    <div className="flex gap-2 leading-none">
      {languages.map((language) => {
        return (
          <button
            disabled={currentStyle === language.style}
            onClick={() => {
              logEvent('style_updated', {
                name: language.style,
              });
              handleUpdateStyle(language.style);
            }}
            key={language.style}
            className={clsx('rounded-2xl px-[16px] py-[14px] leading-5', {
              'bg-[#F5F5FA]': currentStyle !== language.style,
              'cursor-not-allowed bg-[#ceced8]':
                currentStyle === language.style,
              'hover:bg-[#E4EAF1]': currentStyle !== language.style,
            })}
            data-active={currentStyle === language.style}>
            {language.style}
          </button>
        );
      })}
    </div>
  );
};
